export const useCartTransformAPI = (graphql, sale_page_structure) => {
    if(sale_page_structure){
        // Parse the GraphQL query
        const parsedGraphql = graphql
        const input = parsedGraphql.variables.input;
        const lines = input.lines;
        
        // If cart transformation is enabled, transform the cart
        if(sale_page_structure.cartTransformEnabled) {
            // Remove discount codes if any
            if(input.discountCodes) {
                delete input.discountCodes;
            }
            
            // Add line item properties for price and title
            lines.forEach(line => {
                if(!line) return;
                
                const variantId = line.merchandiseId.split('/').pop();
                const itemData = sale_page_structure.items[variantId];
                
                if(itemData) {
                    if(!line.attributes) {
                        line.attributes = [];
                    }
                    
                    // Add custom price property
                    line.attributes.push({
                        key: "_ctf_prc",
                        value: String(itemData.price)
                    });
                    
                    // Add custom title property
                    line.attributes.push({
                        key: "_ctf_ttl",
                        value: itemData.storefrontTitle || ""
                    });
                }
            });
            
            // Add cart-level property for master product list
            const masterProductList = [];
            lines.forEach(line => {
                if(!line) return;
                const variantId = line.merchandiseId.split('/').pop();
                masterProductList.push(variantId);
            });
            
            if(!input.attributes) {
                input.attributes = [];
            }
            
            input.attributes.push({
                key: "_ctf_mst_prd",
                value: JSON.stringify(masterProductList)
            });
        }
        
        // Update the GraphQL query with transformed data
        parsedGraphql.variables.input = input;
        return JSON.stringify(parsedGraphql);
    } else {
        return JSON.stringify(graphql);
    }
}
